import { asyncRoutes, constantRoutes } from '@/router'
// import store from '@/store'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role)
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, role) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, role)
      }
      res.push(tmp)
    }
  })

  return res
}

const getters = {
  addRoutes: state => state.addRoutes
}

const state = {
  routes: [],
  addRoutes: []
}

const profile = []
const clearance = []
const staff = []
const VIPcenter = []
const clearanceException = []

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  CHANGE_ROUTES_ICON: (state, data) => {
    state.routes.forEach((route) => {
      if (route.meta) {
        if (route.meta.title === '报关单证' && clearance.length === 0) {
          clearance.push(route.meta.icon)
        }
        if (route.meta.title === '客户档案' && profile.length === 0) {
          profile.push(route.meta.icon)
        }
        if (route.meta.title === '平台管理' && staff.length === 0) {
          staff.push(route.meta.icon)
        }
        if (route.meta.title === '个人中心' && VIPcenter.length === 0) {
          VIPcenter.push(route.meta.icon)
        }
        if (route.meta.title === '清关异常' && clearanceException.length === 0) {
          clearanceException.push(route.meta.icon)
        }
        if (route.meta.title !== data.title) {
          if (route.meta.title === '报关单证') {
            route.meta.icon = `${clearance[0]}false`
          }
          if (route.meta.title === '清关异常') {
            route.meta.icon = `${clearanceException[0]}`
          }
          if (route.meta.title === '客户档案') {
            route.meta.icon = `${profile[0]}`
          }
          if (route.meta.title === '平台管理') {
            route.meta.icon = `${staff[0]}`
          }
          if (route.meta.title === '个人中心') {
            route.meta.icon = `${VIPcenter[0]}`
          }
        } else {
          route.meta.icon = data.icon
        }
      }
    })
  }
}

const actions = {
  generateRoutes({ commit }, role) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, role)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
